import Table from 'antd/lib/table';
import { ColumnsType } from 'antd/lib/table/interface';
import { useImportContext } from './ImportProvider';

interface IImportFileDescriptionRecord {
    column: string;
    required: string;
    description: string;
}

interface ImportFileDescriptionProps {
    showTitle?: boolean;
}

export function ImportFileDescription({ showTitle = true }: ImportFileDescriptionProps) {
    const { csvConfig } = useImportContext()!;

    const columns: ColumnsType<IImportFileDescriptionRecord> = [
        {
            title: 'Column Name',
            dataIndex: 'column',
            width: 300,
            ellipsis: true,
        },
        {
            title: 'Required',
            dataIndex: 'required',
            width: 100,
            render: text => (text ? 'Yes' : 'No'),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            ellipsis: true,
        },
    ];

    const dataSource = csvConfig.map(({ column, required, description }) => ({ column, required, description }));

    return (
        <Table
            key="import-file-description"
            className="import-file-description"
            rowKey="column"
            size="small"
            scroll={{ x: 'max-content', y: 400 }}
            sticky
            {...(showTitle ? { title: () => 'CSV format description' } : {})}
            columns={columns as any}
            dataSource={dataSource}
            pagination={false}
        ></Table>
    );
}
